// extracted by mini-css-extract-plugin
module.exports = {"author":"Author-module--author--2Yefr","author__bio":"Author-module--author__bio--1Rnp-"};